
export const buttonManager = () => {
  function createRipple(event) {
    const buttonWrapper = event.currentTarget

    const circle = document.createElement('span')

    const btnRect = buttonWrapper.getBoundingClientRect()
    const diameter = Math.max(btnRect.width, btnRect.height)
    const radius = diameter / 2
    circle.style.width = circle.style.height = `${diameter}px`
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    circle.style.left = `${event.clientX - (btnRect.left + radius)}px`
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    circle.style.top = `${event.clientY - (btnRect.top + radius)}px`
    circle.classList.add('ripple')

    const ripple = buttonWrapper.getElementsByClassName('ripple')[0]

    if (ripple) {
      ripple.remove()
    }

    buttonWrapper.appendChild(circle)
  }

  const buttonsWrappers = document.querySelectorAll('.js-buttonWrapper') as unknown as HTMLElement[

  ]
  for (const buttonWrapper of buttonsWrappers) {
    buttonWrapper.addEventListener('click', createRipple)
  }
}
